import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { Banco } from '../../model/financeiro/banco';

@Injectable({
  providedIn: 'root'
})
export class BancoService extends GenericService<Banco>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("banco")
  }
}
